export function i18nFileTreeParser(files) {
  const messages = {}

  files.keys().forEach(key => {
    if (key === './default.json') {
      Object.assign(messages, files(key))
    } else {
      const name = key.replace(/(\.\/|\.json)/g, '')
      messages[name] = files(key)
    }
  })
  return messages
}
